import YYDialog from './dialog'

export default YYDialog